var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.718 6 6.782 8.474V36h-27V6h20.218zm-1.442 3H10.5v24h21V15.526L26.276 9zm-4.772 15c.55 0 .996.443.996.999v1.002a.998.998 0 0 1-.996.999h-5.508a.995.995 0 0 1-.996-.999v-1.002c0-.552.447-.999.996-.999h5.508zm4.494-6a.998.998 0 0 1 1.002.999v1.002c0 .552-.456.999-1.002.999h-9.996A.998.998 0 0 1 15 20.001v-1.002c0-.552.456-.999 1.002-.999h9.996z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.f39f0d3448a223837767da4f4d60e73c.svg";
export { ForwardRef as ReactComponent };